export const validateEan = (body) => {
    const { product, color, client, serial } = body;
    if(product === '' || product === null) throw new Error('Producto vacío');
    if(color === '' || color === null) throw new Error('Color vacío');
    if(client === '' || client === null) throw new Error('Cliente vacío');
    if(serial === '' || serial === null) throw new Error('Serial vacío');
}